export default {"src":"/_next/static/media/slovakia.de6d1c96.svg","height":16,"width":22,"blurWidth":0,"blurHeight":0};